
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/location/edit",
      function () {
        return require("private-next-pages/location/edit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/location/edit"])
      });
    }
  